/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

interface InitialStateType {
  home: any
}
const initialState: InitialStateType = {
  home: {},
}

export const lost_user_gift_package = createAsyncThunk(
  'OldUserRecall/lost_user_gift_package',
  async (params: any = {}, store: any) => {
    const resp = await http.post(
      '/live/gift/lost_user_gift_package',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const lost_user_gift_reward = createAsyncThunk(
  'OldUserRecall/lost_user_gift_reward',
  async (params: any = {}, store: any) => {
    const resp = await http.post(
      '/live/gift/lost_user_gift_reward',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const OldUserRecallSlice = createSlice({
  name: 'OldUserRecall',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(lost_user_gift_package.fulfilled, (state, action) => {
      Object.assign(state.home, action.payload)
    })
  },
})
export default OldUserRecallSlice.reducer
export const OldUserRecallAction = OldUserRecallSlice.actions

export const useOldUserRecallState = () => {
  const data = useSelector((state) => {
    return state.OldUserRecall
  })
  return data
}
